<p class="p-3 mt-3">
  <app-case-widget *permissions="[Permission.SMP_CASE_OVERVIEW_WIDGET]"></app-case-widget>
</p>
